/**
 * Opens the Coverage calculator section in a popup window.
 *
 * Deliberately does not touch sections/slm-coverage-calculator.liquid — that file is regenerated
 * and re-uploaded regularly, so any edit there would be lost. This works purely from the outside:
 * it finds the rendered section, hides it, and reveals it as an overlay when a trigger is clicked.
 *
 * If no trigger button is on the page the section is left completely alone and renders inline,
 * which is how every other template still behaves.
 */
(function () {
  var host = null;
  var lastFocus = null;

  function calculator() {
    return document.getElementById('slmCalc');
  }

  function open() {
    if (!host) return;
    lastFocus = document.activeElement;
    host.classList.add('is-open');
    host.removeAttribute('aria-hidden');
    // Stop the page behind the overlay from scrolling with it.
    document.documentElement.style.overflow = 'hidden';
    var close = host.querySelector('.slm-modal__close');
    if (close) close.focus();
  }

  function close() {
    if (!host) return;
    host.classList.remove('is-open');
    host.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function setup() {
    var triggers = document.querySelectorAll('[data-slm-modal-open]');
    if (!triggers.length) return;

    var calc = calculator();
    if (!calc) return;

    host = calc.closest('.shopify-section') || calc.parentElement;
    if (!host) return;

    host.classList.add('slm-modal-host');
    host.setAttribute('aria-hidden', 'true');

    if (!calc.querySelector('.slm-modal__close')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'slm-modal__close';
      btn.setAttribute('aria-label', 'Close');
      btn.innerHTML = '&times;';
      btn.addEventListener('click', close);
      calc.insertBefore(btn, calc.firstChild);
    }

    Array.prototype.forEach.call(triggers, function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    // Click the backdrop (the host itself, not the calculator) to dismiss.
    host.addEventListener('click', function (e) {
      if (e.target === host) close();
    });

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && host.classList.contains('is-open')) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  // The theme editor re-renders a section on every setting change, which drops the class and the
  // close button. Re-apply so the popup keeps working while the merchant edits.
  document.addEventListener('shopify:section:load', function () {
    host = null;
    setup();
  });
})();
